<template>
    <div class="row">
      <LmEditor
        class="col-12 col-md-12"
        :contentProps="component.componentProps.html"
        @onUpdate="component.componentProps.html = $event; $emit('input', component)"
        :variablesOptions="[
          { id: 0, name: $t('date'), value: 'date' },
          { id: 1, name: $t('name'), value: 'name' }
        ]"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component)"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
    </div>
</template>

<script>
import LmEditor from '@/components/form/elements/lmEditor'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
export default {
  data () {
    return {
      component: {}
    }
  },
  components: {
    LmEditor,
    LmTextInput,
    LmSelect,
    LmConditionalBuilderUi
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    componentData: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String
    }
  },
  methods: {
    initializeComponent () {
      this.component = this.componentData
    }
  },
  created () {
    this.initializeComponent()
  }
}
</script>
